import type { IconProps } from '../types/IconProps.ts';
export const SearchPlus: IconProps = {
    name: 'SearchPlus',
    children: [
        `<path d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16M16.95 17.05 21 21M11 8v6M8 11h6" />`,
    ]
};